// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J6ZxP","colMin":"styles_colMin__1JjIo"};